// extracted by mini-css-extract-plugin
module.exports = {"generateText":"PromptUserInfo_generateText__1xyKh","generateTextInProgress":"PromptUserInfo_generateTextInProgress__zc9Ej"};